import { WorkbookNavItem } from '../⚛️atoms/WorkbookNavItem.jsx';
import { useMemo, useRef, useState } from 'react';
import { WorkbookNavItemScrollArea } from '../❉molecules/WorkbookNavItemScrollArea.jsx';
import { useClickAway } from 'react-use';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { WorkbookNavV2ChapterGroup } from '../❉molecules/WorkbookNavV2ChapterGroup';
import useLockedTranslate from '../../Hooks/useLockedTranslate';
import { getTranslation } from '../../utils/translationHelper';
import { getTemplateLessonId } from '../../utils/workbookV2';

export const WorkbookNavV2 = ({ workbook, activeLesson, pendingLessonId, isNavigating, onClick }) => {
  const navRef = useRef(null);

  const { lang } = useLockedTranslate(workbook);
  const getLocalizedText = (item, key) => {
    if (!item) {
      return '';
    }

    return lang === 'en' ? item[key] ?? '' : getTranslation(item.translations, lang, key, item[key] ?? '');
  };

  useClickAway(navRef, () => {
    // if (!joyrideActive) {
    hideDropdown();
    // }
  });

  const [showDropdown, setShowDropdown] = useState(false);

  const hideDropdown = () => {
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const { currentChapterIndex, currentLesson } = useMemo(() => {
    const lessonId = pendingLessonId ?? getTemplateLessonId(activeLesson);

    if (!lessonId || !workbook?.chapters?.length) {
      return { currentChapterIndex: -1, currentLesson: activeLesson };
    }

    const chapterIndex = workbook.chapters.findIndex((chapter) => {
      return chapter.lessons.findIndex((lesson) => getTemplateLessonId(lesson) === lessonId) >= 0;
    });

    const chapterLesson =
      chapterIndex >= 0 ? workbook.chapters[chapterIndex].lessons.find((lesson) => getTemplateLessonId(lesson) === lessonId) : null;

    return {
      currentChapterIndex: chapterIndex,
      currentLesson: chapterLesson ?? activeLesson
    };
  }, [activeLesson, pendingLessonId, workbook]);

  return (
    <>
      <div className="relative z-50 flex h-full w-full bg-white" ref={navRef}>
        {showDropdown && (
          <>
            <div className="fixed top-0 left-0 h-screen w-screen backdrop-blur-[2px]" onClick={toggleDropdown}></div>
            <div onClick={toggleDropdown} className="absolute top-0 left-0 z-50 h-full w-full">
              <WorkbookNavItemScrollArea>
                {workbook.chapters.map((chapter, index) => {
                  return (
                    <WorkbookNavV2ChapterGroup
                      workbook={workbook}
                      currentLesson={currentLesson}
                      currentChapter={chapter}
                      pendingLessonId={pendingLessonId}
                      isNavigating={isNavigating}
                      key={index}
                      onClick={onClick}
                    />
                  );
                })}
              </WorkbookNavItemScrollArea>
            </div>
          </>
        )}
        <div onClick={toggleDropdown} className="w-full px-3 py-3 lg:max-w-[540px]">
          <div
            className="relative flex items-center rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-sm transition-all hover:shadow-lg data-[pending=true]:border-pdteal/25 data-[pending=true]:shadow-md"
            data-pending={isNavigating}
          >
            <ChevronRightIcon
              className="mr-2 size-7 shrink-0 rounded-md bg-white p-1 text-gray-500 transition-[rotate] data-[show=true]:rotate-90"
              onClick={toggleDropdown}
              data-show={showDropdown}
            />
            <div className="min-w-0 flex-1">
              <WorkbookNavItem
                title={currentChapterIndex >= 0 ? getLocalizedText(workbook.chapters[currentChapterIndex], 'title') : ''}
                subtitle={getLocalizedText(currentLesson, 'title')}
                current={true}
                key={getTemplateLessonId(currentLesson)}
                completed={currentLesson?.completed}
                showCompleted={false}
                buttonLike={true}
                isLoading={isNavigating}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
